/*
* 小游戏相关
* */
import {BOM} from './BOM.js';
import {bridge} from './bridge.js';
import {closeWebview,createProtocol} from './client.js';
import {getPokeUser, trackServer, openUrl,isIos} from './utils.js';


class GameLog {
    constructor(gameName, screenId) {
        this.gameName = gameName;
        this.eventName = 'pokekara_web_mini_game';
        this.screenId = screenId || 'no';
    }

    reportLoadTime() {
        if(!this.startTime){
            BOM.alert('call init method first!');
            return;
        }
        trackServer({
            event: this.eventName,
            label: 'load_success',
            value: this.gameName,
            extra: {
                duration: (new Date().getTime() - this.startTime) / 1000,
                uid:getPokeUser().uid || 'nologin'
            }
        });
        this.loadTimeReported=true;
        if(isIos()){
            bridge.post('update_presentation_ui', {'pull_dismiss_enabled':0});
        }
        //每10秒上报一次停留时间
        setInterval(()=>{
            this.reportPlayTime();
        },10000);
    }

    reportPlayTime(){
        trackServer({
            event: this.eventName,
            label: 'stay_duration',
            value: this.gameName,
            extra: {
                duration: 10,
                uid:getPokeUser().uid || 'nologin'
            }
        });
    }

    reportLoadFailTime() {
        if(!this.loadTimeReported) {
            trackServer({
                event: this.eventName,
                label: 'load_failure',
                value: this.gameName,
                extra: {
                    duration: (new Date().getTime() - this.startTime) / 1000,
                    uid:getPokeUser().uid || 'nologin'
                }
            });
        }
    }

    init() {
        //只初始化一次
        if (!GameLog.instance) {
            this.startTime = new Date().getTime();
            this.loadTimeReported=false;
            if (this.screenId) {
                if(this.screenId === 'no') {
                    openUrl("local://pageloaded");
                }else {
                    openUrl("local://pageloaded?screen_id=" + this.screenId);
                }
            }
            if(isIos()){
                bridge.post('update_presentation_ui', {'pull_dismiss_enabled':1});
            }
            //阻断关闭行为
            BOM.window.mini_game_close = ()=>{
                closeWebview();
                return 1;
            };
            createProtocol('update_back_button',{
                callback: 'mini_game_close'
            });
            GameLog.instance = this;
        }else {
            this.startTime = GameLog.instance.startTime;
            this.loadTimeReported=GameLog.instance.loadTimeReported;
        }
    }
}

GameLog.instance = null;

export {
    GameLog
};
